export function isDateValid(value: Date): boolean {
  return !isNaN(value.valueOf());
}
